"use client";

// @ts-strict-ignore
import styled from "styled-components";
import { mediaQuery } from "@hubble/web";

export const PageContainer = styled.main<{ backgroundColor?: string }>`
  max-width: 1280px;
  margin: 0 auto;
  background-color: ${({ theme, backgroundColor }) => {
    return (
      backgroundColor &&
      (theme.colorPalette[backgroundColor] || backgroundColor || "initial")
    );
  }};
  * {
    box-sizing: border-box;
  }
  &.customMargin {
    margin-top: 44px;
    & > div:first-child {
      position: absolute;
      top: 55px;
      left: 0px;
      height: auto;
      z-index: 22;
      & > div:nth-child(2) {
        & > div:first-child {
          overflow: hidden !important;
        }
      }
      ${(props) =>
        props.theme.media.mobileLandscape`
        position: relative;
        top: 0px;
      `}
    }
  }
`;

export const ContentContainer = styled.section<{ backgroundColor?: string }>`
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor
      ? theme.backgroundColors[backgroundColor] || backgroundColor
      : theme.backgroundColors.primary || "initial"};
  @media ${mediaQuery.mobileXsDown} {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  @media ${mediaQuery.tabletSmUp} {
    padding-left: 3rem;
    padding-right: 3rem;
  }
`;
